import { useState, useEffect, useContext } from 'react';
import * as wasm from 'sched';
import { WorkspaceContext } from '../context/WorkspaceContext';

// Hook to access pending changes
export function useOnlineStatus() {
  const { safeData } = useContext(WorkspaceContext);

  const [online, setOnline] = useState(false);

  useEffect(() => {
    if (!safeData) return;

    const callback = (newOnline: boolean) => {
      setOnline(newOnline);
    };

    const jsCallback = callback as unknown as Function;

    wasm.DataManager.select_online_status(safeData, jsCallback);

    return () => {
      wasm.DataManager.unsubscribe(safeData, jsCallback);
    };
  }, [safeData]);

  return online;
}